__turbopack_context__.v({
  "signModalContent": "Auth-module-scss-module__gz2Ngq__signModalContent",
  "signModalHeader": "Auth-module-scss-module__gz2Ngq__signModalHeader",
});
